
import service from "@/utils/http";
// 获取学科门类
export function subjectList(){
    return service({
     url:"Subject/GetDisciplineCategory",
     method:"get",
    })
 };
 // 获取实验资源
export function experimentlist(data){
    return service({
     url:"VirtualSimulationCourse/GetList",
     method:"post",
     data
    })
 };
  // 获取资源年份
export function CreateYearList(){
    return service({
     url:"VirtualSimulationCourse/CreateYear",
     method:"get",
    })
 }
   // 获取新闻资讯
export function newsList(data){
    return service({
     url:"Home/GetNewsList",
     method:"post",
     data
    })
 }
    // 最新课程（资源）
export function newexperimentlist(data){
    return service({
     url:"Home/GetCourseRecommendList",
     method:"post",
     data
    })
 }
     // 获取课程（资源）排行
export function GetCourseSortList(data){
   return service({
    url:"Home/GetCourseSortList",
    method:"post",
    data
   })
}
     // 获取学院信息
     export function XueYuanList(data){
      return service({
       url:"Unit/GetXueYuanList",
       method:"POST",
       data
      })
   }

   // 免登录
   export function loginfree(data){
      return service({
       url:"User/LoginFree",
       method:"POST",
       data
      })
   }

    // 首页获取访问量统计
    export function VistRecord(data){
      return service({
       url:"Home/VistRecord",
       method:"POST",
       data
      })
   }

     // 首页学习时长统计
     export function LearningTimeStatistics(data){
      return service({
       url:"Home/LearningTimeStatistics",
       method:"POST",
       data
      })
   }


// WEBPACK FOOTER //
// ./src/api/index.js